// puzzleLibrary.js

const puzzleLibrary = [
    {
      date: '2026-09-06',
      theme: 'Adventure',
      words: ['JOURNEY', 'MAP', 'STAR', 'COMPASS', 'TIME'],
      knightTour: [
        24, 7, 20, 13, 22,
        17, 12, 23, 8, 19,
        6, 3, 18, 21, 14,
        11, 16, 1, 4, 9,
        2, 5, 10, 15, 0
      ]
    },
    {
      date: '2026-09-07',
      theme: 'Ocean',
      words: ['WAVES', 'CORAL', 'SHARK', 'BEACH', 'TIDES'],
      knightTour: [
        24, 7, 20, 13, 22,
        17, 12, 23, 8, 19,
        6, 3, 18, 21, 14,
        11, 16, 1, 4, 9,
        2, 5, 10, 15, 0
      ]
    },
    {
      date: '2025-10-27',
      theme: 'Space',
      words: ['ORBIT', 'COMET', 'LUNAR', 'STAR', 'GALAXY'],
      knightTour: [
        0, 15, 10, 5, 2,
        9, 4, 1, 16, 11,
        14, 21, 18, 3, 6,
        19, 8, 23, 12, 17,
        22, 13, 20, 7, 24
      ]
    },
    {
        date: '2025-10-28',
        theme: 'Breakfast',
        words: ['EGGS', 'TOAST', 'JUICE', 'CEREAL', 'BACON'],
        knightTour: [
            18, 5, 0, 11, 24,
            15, 10, 17, 6, 1,
            4, 19, 14, 23, 12,
            9, 16, 21, 2, 7,
            20, 3, 8, 13, 22
        ]
    },
    {
        date: '2025-10-29',
        theme: 'Reading',
        words: ['BOOK', 'PAGE', 'STORY', 'NOVEL', 'CHAPTER'],
        knightTour: [
            22, 11, 16, 3, 24,
            7, 2, 23, 10, 15,
            12, 21, 8, 17, 4,
            1, 6, 19, 14, 9,
            20, 13, 0, 5, 18
        ]
    },
    {
        date: '2025-10-30',
        theme: 'Office',
        words: ['COFFEE', 'DESK', 'EMAIL', 'CHAIR', 'PRINT'],
        knightTour: [
            22, 3, 16, 9, 24,
            13, 8, 23, 4, 15,
            2, 21, 14, 17, 10,
            7, 12, 19, 0, 5,
            20, 1, 6, 11, 18
        ]
    },
    {
        date: '2025-10-31',
        theme: 'Halloween',
        words: ['CANDY', 'PUMPKIN', 'GHOST', 'BAT', 'TRICK'],
        knightTour: [
            22, 11, 16, 5, 24,
            3, 6, 23, 10, 15,
            12, 21, 4, 17, 0,
            7, 2, 19, 14, 9,
            20, 13, 8, 1, 18
        ]
    },
    {
      date: '2025-11-01',
      theme: 'Retro',
      words: ['VINYL', 'DISCO', 'PIXEL', 'TAPES', 'FLASH'],
      knightTour: [
        22, 9, 4, 15, 20,
        3, 14, 21, 10, 5,
        8, 23, 2, 19, 16,
        13, 0, 17, 6, 11,
        24, 7, 12, 1, 18
      ]
    },
    {
      date: '2025-11-02',
      theme: 'Motion',
      words: ['RUSH', 'DASH', 'ZOOM', 'GLIDE', 'SWIFT', 'JET'],
      knightTour: [
          22, 11, 16, 5, 24,
          3, 6, 23, 10, 15,
          12, 21, 4, 17, 0,
          7, 2, 19, 14, 9,
          20, 13, 8, 1, 18
      ]
    },
    {
      date: '2025-11-03',
      theme: 'Earth',
      words: ['CLAY', 'ORE', 'SAND', 'ROCK', 'SONTE', 'FLINT'],
      knightTour: [
          22, 11, 16, 5, 24,
          3, 6, 23, 10, 15,
          12, 21, 4, 17, 0,
          7, 2, 19, 14, 9,
          20, 13, 8, 1, 18
      ]
    },
    {
      date: '2025-11-04',
      theme: 'Halloween',
      words: ['CANDY', 'PUMPKIN', 'GHOST', 'BAT', 'TRICK'],
      knightTour: [
          22, 11, 16, 5, 24,
          3, 6, 23, 10, 15,
          12, 21, 4, 17, 0,
          7, 2, 19, 14, 9,
          20, 13, 8, 1, 18
      ]
    },
    {
      date: '2025-11-05',
      theme: 'Halloween',
      words: ['CANDY', 'PUMPKIN', 'GHOST', 'BAT', 'TRICK'],
      knightTour: [
          22, 11, 16, 5, 24,
          3, 6, 23, 10, 15,
          12, 21, 4, 17, 0,
          7, 2, 19, 14, 9,
          20, 13, 8, 1, 18
      ]
    },
    {
      date: '2025-11-06',
      theme: 'Cats',
      words: ['BENGAL', 'SIAMESE', 'CALICO', 'BOMBAY'],
      knightTour: [
        22, 11, 16, 5, 24,
        3, 6, 23, 10, 15,
        12, 21, 4, 17, 0,
        7, 2, 19, 14, 9,
        20, 13, 8, 1, 18
      ]
    },
    {
      date: '2025-11-07',
      theme: 'Graphs',
      words: ['BAR', 'PIE', 'DIAMOND', 'CIRCLE', 'SQUARE'],
      knightTour: [
        22, 15, 10, 5, 20,
        9, 0, 21, 16, 11,
        14, 23, 4, 19, 6,
        1, 8, 17, 12, 3,
        24, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-11-08',
      theme: 'S&P 500',
      words: ['AAPL', 'MSFT', 'GOOGL', 'AMZN', 'META'],
      knightTour: [
        24, 7, 20, 13, 22,
        17, 12, 23, 8, 19,
        6, 3, 18, 21, 14,
        11, 16, 1, 4, 9,
        2, 5, 10, 15, 0
      ]
    },
    {
      date: '2025-11-09',
      theme: 'Stationery',
      words: ['PENCIL', 'ERASER', 'SCISSORS', 'RULER'],
      knightTour: [
        22, 9, 4, 15, 20,
        3, 14, 21, 10, 5,
        8, 23, 2, 19, 16,
        13, 0, 17, 6, 11,
        24, 7, 12, 1, 18
      ]
    },
    {
      date: '2025-11-10',
      theme: 'Collections',
      words: ['BOOKS', 'CDS', 'MOVIES', 'GAMES', 'STAMPS'],
      knightTour: [
        22, 11, 16, 5, 24,
        3, 6, 23, 10, 15,
        12, 21, 4, 17, 0,
        7, 2, 19, 14, 9,
        20, 13, 8, 1, 18
      ]
    },
    {
      date: '2025-11-11',
      theme: 'Natural Patterns',
      words: ['FRACTAL', 'SPIRAL', 'WAVES', 'LATTICE'],
      knightTour: [
        22, 11, 16, 3, 24,
        7, 2, 23, 10, 15,
        12, 21, 8, 17, 4,
        1, 6, 19, 14, 9,
        20, 13, 0, 5, 18
      ]
    },
    {
      date: '2025-11-12',
      theme: 'Emotions',
      words: ['ANXIETY', 'SADNESS', 'CALM', 'DISGUST'],
      knightTour: [
        24, 3, 14, 9, 22,
        13, 8, 23, 4, 15,
        0, 17, 2, 21, 10,
        7, 12, 19, 16, 5,
        18, 1, 6, 11, 20
      ]
    },
    {
      date: '2025-11-13',
      theme: 'Fandoms',
      words: ['MARVEL', 'DC', 'DISNEY', 'HARRYPOTTER'],
      knightTour: [
        24, 5, 14, 11, 22,
        15, 10, 23, 6, 13,
        4, 1, 12, 21, 18,
        9, 16, 19, 2, 7,
        0, 3, 8, 17, 20
      ]
    },
    {
      date: '2025-11-14',
      theme: 'Unlock',
      words: ['PASSWORD', 'PIN', 'KEY', 'FINGERPRINT'],
      knightTour: [
        24, 3, 14, 9, 22,
        13, 8, 23, 4, 15,
        0, 17, 2, 21, 10,
        7, 12, 19, 16, 5,
        18, 1, 6, 11, 20
      ]
    },
    {
      date: '2025-11-15',
      theme: 'Kitchen',
      words: ['CUP', 'SPOON', 'KNIFE', 'FORK', 'PLATE', 'POT'],
      knightTour: [
        18, 5, 0, 11, 24,
        15, 10, 17, 6, 1,
        4, 19, 14, 23, 12,
        9, 16, 21, 2, 7,
        20, 3, 8, 13, 22
      ]
    },
    {
      date: '2025-11-16',
      theme: 'Scent',
      words: ['FRAGRANCE', 'SPRAY', 'DIFFUSER', 'OIL'],
      knightTour: [
        24, 5, 14, 11, 22,
        15, 10, 23, 6, 13,
        4, 1, 12, 21, 18,
        9, 16, 19, 2, 7,
        0, 3, 8, 17, 20
      ]
    },
    {
      date: '2025-11-17',
      theme: 'With you',
      words: ['WALLET', 'PHONE', 'KEYS', 'PEN', 'EARBUDS'],
      knightTour: [
        22, 15, 10, 5, 20,
        9, 0, 21, 16, 11,
        14, 23, 4, 19, 6,
        1, 8, 17, 12, 3,
        24, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-11-18',
      theme: 'PhotoFilters',
      words: ['GREYSCALE', 'SEPIA', 'VINTAGE', 'BLUR'],
      knightTour: [
        22, 11, 16, 5, 24,
        9, 4, 23, 0, 15,
        12, 21, 10, 17, 6,
        3, 8, 19, 14, 1,
        20, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-11-19',
      theme: 'npm',
      words: ['START', 'INSTALL', 'UPDATE', 'PUBLISH'],
      knightTour: [
        22, 15, 10, 5, 20,
        9, 4, 21, 16, 11,
        14, 23, 0, 19, 6,
        3, 8, 17, 12, 1,
        24, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-11-20',
      theme: 'Mushroom',
      words: ['OYSTER', 'ENOKI', 'PORTOBELLO', 'LION'],
      knightTour: [
          22, 11, 16, 5, 24,
          3, 6, 23, 10, 15,
          12, 21, 4, 17, 0,
          7, 2, 19, 14, 9,
          20, 13, 8, 1, 18
      ]
    },
    {
      date: '2025-11-21',
      theme: 'Cost',
      words: ['AMOUNT', 'PRICE', 'CHARGE', 'VALUE', 'FEE'],
      knightTour: [
        22, 15, 10, 5, 20,
        9, 0, 21, 16, 11,
        14, 23, 4, 19, 6,
        1, 8, 17, 12, 3,
        24, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-11-22',
      theme: 'Desert',
      words: ['DUNE', 'SAND', 'CACTUS', 'SAHARA', 'OASIS'],
      knightTour: [
        22, 3, 16, 9, 24,
        13, 8, 23, 4, 15,
        2, 21, 14, 17, 10,
        7, 12, 19, 0, 5,
        20, 1, 6, 11, 18
      ]
    },
    {
      date: '2025-11-23',
      theme: 'Chess',
      words: ['KING', 'QUEEN', 'ROOK', 'BISHOP', 'KNIGHT'],
      knightTour: [
        22, 11, 16, 3, 24,
        7, 2, 23, 10, 15,
        12, 21, 8, 17, 4,
        1, 6, 19, 14, 9,
        20, 13, 0, 5, 18
      ]
    },
    {
      date: '2025-11-24',
      theme: 'Room',
      words: ['BED', 'MAIL', 'BOARD', 'MUD', 'GUEST', 'CLASS'],
      knightTour: [
        22, 11, 16, 5, 24,
        9, 4, 23, 0, 15,
        12, 21, 10, 17, 6,
        3, 8, 19, 14, 1,
        20, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-11-25',
      theme: 'Magic',
      words: ['WAND', 'SPELL', 'POTION', 'CHARM', 'CURSE'],
      knightTour: [
        22, 11, 16, 3, 24,
        7, 2, 23, 10, 15,
        12, 21, 8, 17, 4,
        1, 6, 19, 14, 9,
        20, 13, 0, 5, 18
      ]
    },
    {
      date: '2025-11-26',
      theme: 'Influencer',
      words: ['POST', 'SHARE', 'STORY', 'LIKE', 'COMMENT'],
      knightTour: [
        22, 11, 16, 5, 24,
        9, 4, 23, 0, 15,
        12, 21, 10, 17, 6,
        3, 8, 19, 14, 1,
        20, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-11-27',
      theme: 'Long time',
      words: ['ERA', 'ETERNITY', 'CENTURY', 'FOREVER'],
      knightTour: [
        24, 9, 20, 15, 0,
        21, 14, 23, 10, 19,
        8, 5, 18, 1, 16,
        13, 22, 3, 6, 11,
        4, 7, 12, 17, 2
      ]
    },
    {
      date: '2025-11-28',
      theme: 'Measure',
      words: ['DISTANCE', 'WEIGHT', 'VOLUME', 'SPEED'],
      knightTour: [
        22, 3, 16, 9, 24,
        13, 8, 23, 4, 15,
        2, 21, 14, 17, 10,
        7, 12, 19, 0, 5,
        20, 1, 6, 11, 18
      ]
    },
    {
      date: '2025-11-29',
      theme: 'Bridges',
      words: ['CANTILEVER', 'TRUSS', 'SUSPENSION'],
      knightTour: [
        22, 11, 16, 3, 24,
        7, 2, 23, 10, 15,
        12, 21, 8, 17, 4,
        1, 6, 19, 14, 9,
        20, 13, 0, 5, 18
      ]
    },
    {
      date: '2025-11-30',
      theme: 'Direction',
      words: ['NORTH', 'SOUTH', 'EAST', 'WEST', 'BEARING'],
      knightTour: [
        22, 9, 4, 15, 20,
        3, 14, 21, 10, 5,
        8, 23, 2, 19, 16,
        13, 0, 17, 6, 11,
        24, 7, 12, 1, 18
      ]
    },
    {
      date: '2025-12-01',
      theme: 'Cafe',
      words: ['COFFEE', 'LATTE', 'CAPPUCCINO', 'CHAI'],
      knightTour: [
        24, 3, 14, 9, 22,
        13, 8, 23, 4, 15,
        0, 17, 2, 21, 10,
        7, 12, 19, 16, 5,
        18, 1, 6, 11, 20
      ]
    },
    {
      date: '2025-12-02',
      theme: 'Job',
      words: ['RESUME', 'INTERVIEW', 'TESTS', 'OFFER'],
      knightTour: [
        0, 13, 18, 7, 24,
        5, 8, 1, 12, 17,
        14, 19, 6, 23, 2,
        9, 4, 21, 16, 11,
        20, 15, 10, 3, 22
      ]
    },
    {
      date: '2025-12-03',
      theme: 'Takeout',
      words: ['UBER', 'DOORDASH', 'INSTACART', 'SKIP'],
      knightTour: [
        18, 5, 0, 11, 24,
        15, 10, 17, 6, 1,
        4, 19, 14, 23, 12,
        9, 16, 21, 2, 7,
        20, 3, 8, 13, 22
      ]
    },
    {
      date: '2025-12-04',
      theme: 'Ball',
      words: ['BASKET', 'DODGE', 'BASE', 'TENNIS', 'GOLF'],
      knightTour: [
        22, 15, 10, 5, 20,
        9, 4, 21, 16, 11,
        14, 23, 0, 19, 6,
        3, 8, 17, 12, 1,
        24, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-12-05',
      theme: 'Fabric',
      words: ['WOOL', 'COTTON', 'VISCOSE', 'ACRYLIC'],
      knightTour: [
        22, 3, 16, 9, 24,
        13, 8, 23, 4, 15,
        2, 21, 14, 17, 10,
        7, 12, 19, 0, 5,
        20, 1, 6, 11, 18
      ]
    },
    {
      date: '2025-12-06',
      theme: 'Birthday',
      words: ['MASSAGE', 'COMEDY', 'STEAK', 'PARTY', '26' ],
      knightTour: [
        24, 9, 20, 15, 0,
        21, 14, 23, 10, 19,
        8, 5, 18, 1, 16,
        13, 22, 3, 6, 11,
        4, 7, 12, 17, 2
      ]
    },
    {
      date: '2025-12-07',
      theme: 'Video call',
      words: ['FACETIME', 'WHATSAPP', 'ZOOM', 'SKYPE'],
      knightTour: [
        0, 13, 18, 7, 24,
        5, 8, 1, 12, 17,
        14, 19, 6, 23, 2,
        9, 4, 21, 16, 11,
        20, 15, 10, 3, 22
      ]
    },
    {
      date: '2025-12-08',
      theme: 'Flower',
      words: ['TULIP', 'ROSE', 'ORCHID', 'DAISY', 'LOTUS'],
      knightTour: [
        24, 9, 20, 15, 0,
        21, 14, 23, 10, 19,
        8, 5, 18, 1, 16,
        13, 22, 3, 6, 11,
        4, 7, 12, 17, 2
      ]
    },
    {
      date: '2025-12-09',
      theme: 'Coding language',
      words: ['PYTHON', 'JAVASCRIPT', 'SWIFT', 'SCALA'],
      knightTour: [
        22, 15, 10, 5, 20,
        9, 0, 21, 16, 11,
        14, 23, 4, 19, 6,
        1, 8, 17, 12, 3,
        24, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-12-10',
      theme: 'Health metrics',
      words: ['SLEEP', 'STRESS', 'MOVEMENT', 'CYCLES'],
      knightTour: [
        24, 3, 14, 9, 22,
        13, 8, 23, 4, 15,
        0, 17, 2, 21, 10,
        7, 12, 19, 16, 5,
        18, 1, 6, 11, 20
      ]
    },
    {
      date: '2025-12-11',
      theme: 'Poker',
      words: ['BLUFF', 'RAISE', 'FLUSH', 'RIVER', 'CHIPS'],
      knightTour: [
        24, 5, 14, 11, 22,
        15, 10, 23, 6, 13,
        4, 1, 12, 21, 18,
        9, 16, 19, 2, 7,
        0, 3, 8, 17, 20
      ]
    },
    {
      date: '2025-12-12',
      theme: 'Metals',
      words: ['GOLD', 'SILVER', 'COPPER', 'NICKEL', 'TIN'],
      knightTour: [
        18, 5, 0, 11, 24,
        15, 10, 17, 6, 1,
        4, 19, 14, 23, 12,
        9, 16, 21, 2, 7,
        20, 3, 8, 13, 22
      ]
    },
    {
      date: '2025-12-13',
      theme: 'Finishes',
      words: ['MATTE', 'GLOSS', 'SATIN', 'WAX', 'PLASTER'],
      knightTour: [
        0, 13, 18, 7, 24,
        5, 8, 1, 12, 17,
        14, 19, 6, 23, 2,
        9, 4, 21, 16, 11,
        20, 15, 10, 3, 22
      ]
    },
    {
      date: '2025-12-14',
      theme: 'Clothing prints',
      words: ['STRIPE', 'GINGHAM', 'CHEETAH', 'SNAKE'],
      knightTour: [
        18, 5, 0, 11, 24,
        15, 10, 17, 6, 1,
        4, 19, 14, 23, 12,
        9, 16, 21, 2, 7,
        20, 3, 8, 13, 22
      ]
    },
    {
      date: '2025-12-15',
      theme: 'Bougie',
      words: ['GUCCI', 'YSL', 'CHANEL', 'CARTIER', 'DIOR'],
      knightTour: [
        22, 15, 10, 5, 20,
        9, 0, 21, 16, 11,
        14, 23, 4, 19, 6,
        1, 8, 17, 12, 3,
        24, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-12-16',
      theme: 'Apple',
      words: ['MAC', 'IPHONE', 'IPAD', 'AIRPODS', 'WATCH'],
      knightTour: [
        24, 9, 20, 15, 0,
        21, 14, 23, 10, 19,
        8, 5, 18, 1, 16,
        13, 22, 3, 6, 11,
        4, 7, 12, 17, 2
      ]
    },
    {
      date: '2025-12-17',
      theme: 'Coats and Jackets',
      words: ['RAIN', 'TRENCH', 'PARKA', 'PEA', 'VARSITY'],
      knightTour: [
        22, 3, 16, 9, 24,
        13, 8, 23, 4, 15,
        2, 21, 14, 17, 10,
        7, 12, 19, 0, 5,
        20, 1, 6, 11, 18
      ]
    },
    {
      date: '2025-12-18',
      theme: 'Puzzles',
      words: ['CROSSWORD', 'JIGSAW', 'SUDOKU', 'MAZE'],
      knightTour: [
        0, 13, 18, 7, 24,
        5, 8, 1, 12, 17,
        14, 19, 6, 23, 2,
        9, 4, 21, 16, 11,
        20, 15, 10, 3, 22
      ]
    },
    {
      date: '2025-12-19',
      theme: 'School',
      words: ['HIGH', 'MIDDLE', 'PRIMARY', 'GRADUATE'],
      knightTour: [
        18, 5, 0, 11, 24,
        15, 10, 17, 6, 1,
        4, 19, 14, 23, 12,
        9, 16, 21, 2, 7,
        20, 3, 8, 13, 22
      ]
    },
    {
      date: '2025-12-20',
      theme: 'Sound',
      words: ['PITCH', 'VOLUME', 'FREQUENCY', 'CHORD'],
      knightTour: [
        22, 3, 16, 9, 24,
        13, 8, 23, 4, 15,
        2, 21, 14, 17, 10,
        7, 12, 19, 0, 5,
        20, 1, 6, 11, 18
      ]
    },
    {
      date: '2025-12-21',
      theme: 'Boats',
      words: ['CANOE', 'SAIL', 'PADDLE', 'KAYAK', 'YACHT'],
      knightTour: [
        18, 5, 0, 11, 24,
        15, 10, 17, 6, 1,
        4, 19, 14, 23, 12,
        9, 16, 21, 2, 7,
        20, 3, 8, 13, 22
      ]
    },
    {
      date: '2025-12-22',
      theme: 'AI Tools',
      words: ['CHATGPT', 'CLAUDE', 'GEMINI', 'CURSOR'],
      knightTour: [
        22, 3, 16, 9, 24,
        13, 8, 23, 4, 15,
        2, 21, 14, 17, 10,
        7, 12, 19, 0, 5,
        20, 1, 6, 11, 18
      ]
    },
    {
      date: '2025-12-23',
      theme: 'Starches',
      words: ['POTATO', 'RICE', 'PASTA', 'BREAD', 'FLOUR'],
      knightTour: [
        22, 11, 16, 3, 24,
        7, 2, 23, 10, 15,
        12, 21, 8, 17, 4,
        1, 6, 19, 14, 9,
        20, 13, 0, 5, 18
      ]
    },
    {
      date: '2025-12-24',
      theme: 'Calculator',
      words: ['NUMBER', 'OPERATION', 'DEGREE', 'TRIG'],
      knightTour: [
        0, 13, 18, 7, 24,
        5, 8, 1, 12, 17,
        14, 19, 6, 23, 2,
        9, 4, 21, 16, 11,
        20, 15, 10, 3, 22
      ]
    },
    {
      date: '2025-12-25',
      theme: 'Christmas',
      words: ['SANTA', 'ELF', 'PRESENTS', 'MISTLETOE'],
      knightTour: [
        22, 11, 16, 3, 24,
        7, 2, 23, 10, 15,
        12, 21, 8, 17, 4,
        1, 6, 19, 14, 9,
        20, 13, 0, 5, 18
      ]
    },
    {
      date: '2025-12-26',
      theme: 'Hobbies',
      words: ['PAINT', 'READ', 'GAME', 'DANCE', 'PUZZLE'],
      knightTour: [
        22, 15, 10, 5, 20,
        9, 4, 21, 16, 11,
        14, 23, 0, 19, 6,
        3, 8, 17, 12, 1,
        24, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-12-27',
      theme: 'Socials',
      words: ['SNAP', 'TIKTOK', 'INSTAGRAM', 'REDDIT'],
      knightTour: [
        24, 9, 20, 15, 0,
        21, 14, 23, 10, 19,
        8, 5, 18, 1, 16,
        13, 22, 3, 6, 11,
        4, 7, 12, 17, 2
      ]
    },
    {
      date: '2025-12-28',
      theme: 'In the sky',
      words: ['PLANE', 'BIRD', 'BALLOON', 'CLOUDS', 'SUN'],
      knightTour: [
        24, 7, 20, 13, 22,
        17, 12, 23, 8, 19,
        6, 3, 18, 21, 14,
        11, 16, 1, 4, 9,
        2, 5, 10, 15, 0
      ]
    },
    {
      date: '2025-12-29',
      theme: 'New gen lingo',
      words: ['UNC', 'SIGMA', 'CHOP', 'AURAFARM', 'SYBAU'],
      knightTour: [
        22, 15, 10, 5, 20,
        9, 4, 21, 16, 11,
        14, 23, 0, 19, 6,
        3, 8, 17, 12, 1,
        24, 13, 2, 7, 18
      ]
    },
    {
      date: '2025-12-30',
      theme: 'Dispense',
      words: ['DELIVER', 'SQUIRT', 'PROVIDE', 'GRANT'],
      knightTour: [
        22, 11, 16, 3, 24,
        7, 2, 23, 10, 15,
        12, 21, 8, 17, 4,
        1, 6, 19, 14, 9,
        20, 13, 0, 5, 18
      ]
    },
    {
      date: '2025-12-31',
      theme: 'Lip',
      words: ['LINE', 'STICK', 'BALM', 'OIL', 'GLOSS', 'TINT'],
      knightTour: [
        18, 5, 0, 11, 24,
        15, 10, 17, 6, 1,
        4, 19, 14, 23, 12,
        9, 16, 21, 2, 7,
        20, 3, 8, 13, 22
      ]
    },
  ];
  
  /**
   * Get the puzzle for a specific date
   * @param {Date} date - The date to get the puzzle for
   * @returns {Object} The puzzle object for that date
   */
  export function getPuzzleForDate(date = new Date()) {
    // Convert date to EST by formatting directly
    const dateString = date.toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
    //const dateString = estDate.toISOString().split('T')[0];
    
    // Find exact match first
    let puzzle = puzzleLibrary.find(p => p.date === dateString);
    
    // If no exact match, use cycling based on days since epoch
    if (!puzzle) {
      const startDate = new Date('2025-01-01');
      const daysSinceStart = Math.floor((dateString - startDate) / (1000 * 60 * 60 * 24));
      const index = daysSinceStart % puzzleLibrary.length;
      puzzle = puzzleLibrary[index];
    }
    
    return puzzle;
  }
  
  /**
   * Get today's puzzle (in EST timezone)
   * @returns {Object} Today's puzzle
   */
  export function getTodaysPuzzle() {
    return getPuzzleForDate(new Date());
  }
  
  /**
   * Generate the letter grid from knight tour and words
   * @param {Array} knightTour - The knight tour sequence
   * @param {Array} words - The words to encode
   * @returns {Array} The letter grid
   */
  export function generateLetterGrid(knightTour, words) {
    const combined = words.join('').split('');
    const letters = Array(25).fill('');
    
    knightTour.forEach((stepNumber, gridIndex) => {
      letters[gridIndex] = combined[stepNumber];
    });
    
    return letters;
  }
  
  export default puzzleLibrary;